module.exports = __webpack_public_path__ + "static/media/contact.d995be94.svg";